import SendInvoiceForm from 'pages/Invoice/SendInvoiceForm';

function SendInvoice() {
    return (
        <div>
            <SendInvoiceForm />
        </div>
    );
}

export default SendInvoice;
